export const epicHomes = [
  {
    id: '30CEA16682AH',
    slug: 'the-tuscany',
  },
  {
    id: '30CEA16763AH',
    slug: 'the-sydney',
  },
  {
    id: '30CEE28563BH',
    slug: 'the-explorer',
  },
  {
    id: '30CEE16763EH',
    slug: 'the-mariner',
  },
  {
    id: '30CEA28563AH',
    slug: 'the-rio',
  },
  {
    id: '30CEA16682AH',
    slug: 'the-tuscany',
  },
  {
    id: '30CEA28684AH',
    slug: 'the-morocco',
  },
  {
    id: '30CEA32764AH',
    slug: 'the-everest',
  },
  {
    id: '30CEE16682AH',
    slug: 'the-tide',
  },
  {
    id: '30CEE32603AH',
    slug: 'the-safari',
  },
  {
    id: '30CEE32764AH',
    slug: 'the-summit',
  },
];
